import React from 'react';
import styles from './CheckoutPage.module.css';
import { formatMoney } from 'Logic/Functions/UtilsFunctions';
import { ICheckoutSummaryCardProps } from '@model/Checkout.model';

const CheckoutSummaryCard: React.FC<ICheckoutSummaryCardProps> = ({ item, imageSrc }) => {
  return (
    <li className={styles.receiptRow} data-testid={`checkout-summary-item-${item.id}`}>
      <div className={styles.receiptRowLeft}>
        {imageSrc ? (
          <img src={imageSrc} alt={item.name} className={styles.receiptThumb} />
        ) : (
          <div className={styles.receiptThumbPlaceholder} aria-hidden="true" />
        )}

        <div className={styles.receiptItemInfo}>
          <div className={styles.receiptItemName} title={item.name}>
            {item.name}
          </div>

          <div className={styles.receiptItemMeta}>
            <span className={styles.receiptQty}>Qty: {item.quantity}</span>
            <span className={styles.receiptDot} aria-hidden="true">
              •
            </span>
            <span className={styles.receiptUnit}>
              Unit: {formatMoney(Number(item.unitPrice || 0))}
            </span>
          </div>

          <div className={styles.receiptBreakdown}>
            <div className={styles.receiptBreakdownRow}>
              <span className={styles.receiptBreakdownLabel}>
                {item.quantity} × {formatMoney(Number(item.unitPrice || 0))}
              </span>
              <span className={styles.receiptDots} aria-hidden="true" />
              <span className={styles.receiptBreakdownValue}>
                {formatMoney(Number(item.totalPrice || 0))}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.receiptRowRight}>
        <span className={styles.receiptLineTotal}>{formatMoney(Number(item.totalPrice || 0))}</span>
      </div>
    </li>
  );
};

export default CheckoutSummaryCard;
